export default {"src":"/_next/static/media/close_24.45a318e0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};